/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from "axios";
import Spinner from "helpers/Spinner";
import { baseUrl, localUrl } from "@ora/recursos/src/helpers/Url";
import ModalCard from "layouts/mainsection/components/ModalCard";
import { nanoid } from "nanoid";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import helperStorage from "./helperStorage";
import { import_current_tab, import_set_data, import_success_import, import_reset_tab } from './store'

const styleFileLoaded = {
  fontSize: '2.5em'
}

class ImportarStep4 extends Component {
  state = {
    nameCurrentFile: 'Buscar',
    activeModalRecurso: false,
    selResource: -1,
    selSubLineaTem: -1,
    listResources: []
  }
  constructor (props) {
    super(props)
    console.log('Constructo step3')

  }
  componentDidUpdate (props, state) {
    console.log('update import step 3', this, state, this.state)
    console.log('update import step 3', props, this.props)
    if (props.importData.typeInformation !== this.props.importData.typeInformation) {
      this.getResourceByTypeIOfformation(this.props.importData.typeInformation)
    }
  }
  getResourceByTypeIOfformation =  (type_information_id) => {
    console.log('getResourceByTypeIOfformation')
    axios.get(baseUrl(`aro/variable/${type_information_id}/recursos`)).then(res => {
      // this.props.import_setRecursos(res.data.success ? res.data.data : [])
      this.setState({
        listResources: res.data.success ? res.data.data : []
      })
    })
  }
  componentDidMount () {
    console.log('mounted step3', this.state, this.props)
    // this.props.import_set_data({resource: 999999})
  }
  disabledProcesar = () => {
    return true;
  }
  OnClick_openModal = () => {
    
    this.setState({
      activeModalRecurso: true
    })
  }
  OnClick_nuevo = (evt) => {
    this.props.import_reset_tab()
  }
  onChange = (evt) => {
    const value = evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value;
    
    if (evt.target.name === 'selResource') {
      this.setState({
        selResource: evt.target.value
      })
    }
    if (evt.target.name === 'sub_linea_tematica') {
      this.setState({
        selSubLineaTem: evt.target.value
      })
    }
    if (evt.target.name === 'file-doc') {
        //change name curretn file
        let tn = 'Buscar'
        if (evt.target.files[0]) {
            tn = evt.target.files[0].name
        }
        this.setState({
            nameCurrentFile: tn
        })
    }

    this.setState({
      [evt.target.name]: value,
    });
  }
  textprueba = () => {
    console.log(this.props)
    console.log(this.state)
    return this.props.currentTab;
  }

  tBodyTableConfig = () => {
    // importData.table.file_structure//file
    // importData.table.structure//table
    return this.props.importData.table.file_structure.map((col, index) => {
      // console.log('props in select update', this.props);
      if (this.props.tableStructure.length > 0) {
        let ti = this.props.tableStructure.findIndex(tsitem => tsitem === col.col_table)
        col.col_table = this.props.tableStructure[ ti >= 0 ? ti : 0]
        // this.props.import_set_column({index, col})
      }
      return (
        <tr key={index}>
          <td>{col.value}</td>
          <td>
            <select onChange={ evet => {
              // console.log('change sselect to table', evet.target.value)
              col.col_table = evet.target.value
              this.props.import_set_column({index: col.index, col})
            }} name={`columntable-${col.index}`} required="required">
                      {this.props.importData.table.structure.map((cT, iT) => <option key={iT} value={cT}>{cT}</option>)}
            </select>
          </td>
        </tr>
      )
    })
    // return (
    //   <tr></tr>
    // )
  }
  onSubmit_Step4 = (event) => {
    event.preventDefault()
        // let sendData = this.state
        // Spinner.show()
        // let sendData = new FormData(document.getElementById('frmImportStep4'));
        
        // // sendData.append('tempid', 'IDT' + nanoid(10).toString())
        // axios.put(baseUrl('cites/import/file/' + this.props.importData.idFileName), this.props.importData.table, {
        //   onUploadProgress: function(progressEvent) {
        //     var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        //     console.log(percentCompleted)
        //   }
        // }).then(res => {
        //   Spinner.hide()
        //   if (res.data.success) {
        //     this.props.import_current_tab(4)
        //     // helperStorage.set({
        //     //   id: res.data.id,
        //     //   filename: res.data.filename,
        //     //   step: 1
        //     // })
        //   }
        // }).catch(err => Spinner.hide())
  }
  CoptionRecursos = () => this.state.listResources.map((item, index) => <option key={index} value={ item.id }>{ item.name}</option>)

  render () {
    return (
      <div id={ this.props.id } className={this.props.className}>
        <form id="frmImportStep4" onSubmit={ this.onSubmit_Step4 }>
        <div className="field is-horizontal">
            <h2 className="title">Resultado de importación</h2>
          </div>
          
          <div className="field is-horizontal">
            <ul>
              <li>              
                <label className="label">{this.props.importData.typeInformationName}</label>
              </li>
              <li>              
                <label className="label">{this.props.importData.resourceName}</label>
              </li>
           </ul>

          </div>

          <hr />
          <div className="field center">
          <h2><b>Se procesaron {this.props.importProcesado.registros} registros, en {this.props.importProcesado.tiempo}</b></h2>
          <h2><b><i className="fas fa-check-circle"></i> {this.props.importProcesado.successRow} registros importados sin problemas</b></h2>
          <h3><Link to={localUrl('/' + this.props.importProcesado.linkSuccess) }>Ir a datos importados</Link></h3>
          <h2><b><i className="fas fa-times-circle"></i> {this.props.importProcesado.failRow} registros no se lograron importa</b></h2>
          <h3><a href={baseUrl(this.props.importProcesado.linkFileError)}>Descargar registro no importados</a></h3>
          <h4>Revise los datos y vuelva a importar los registros faltantes</h4>

          </div>
          <hr />
          <div className="field is-horizontal">

            <div className="field-body">
              <div className="field">

                <div className="field">

                  <div className="field-body is-pulled-right">
                    <div className="field is-grouped">
                      <div className="control">
                        <button type="button"  className="button is-primary">
                          <a className="" onClick={this.OnClick_nuevo} href={localUrl("/recoleccion/importar/archivos")}>Nueva importación</a>
                        </button></div>

                    </div>
                  </div>

                </div>

              </div>
            </div>

            </div>
          
        </form>
     
      </div>
    )
  }
}

const mapStateToProps = (state, props /*, ownProps*/) => {
  console.log('mapStateToProps import2',state)
    return {
      currentTab: state.reducerTab.tab,
      importData: state.reducerData,
      importProcesado: state.reducerProcesar,
      tableStructure: state.reducerData.table.structure,

    }
  }
export default connect(mapStateToProps, {
  import_current_tab,
  import_reset_tab,
  import_set_data,  
  import_success_import,
  import_set_column: (data) => {
    return {
      type: 'IMPORT_UPDATE_STRUCTURE',
      payload: data
    }
  }
})(ImportarStep4)